import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
    }, 100);
    
  };


  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('user_lang', lng);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-gray-900/80 backdrop-blur-md'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <img
              src={isScrolled
                ? "https://static.readdy.ai/image/4f8e52dde3dda7b1227768a95bdc6f97/4595d76c80b5322e477f2894d2f3301b.png"
                : "https://storage.readdy-site.link/project_files/7fffb91f-5f53-4051-921b-39ed0fb3fd56/e53a30a6-3038-4920-be13-e122df719f57_w1a424de2-804d-41f8-8e1b-2c3badd94023.png?v=2236fc9176eacedd36bde2691e97c3c8"
              }
              alt="Zimbet32 Logo"
              className="h-12 w-auto transition-opacity duration-300"
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8 absolute left-1/2 transform -translate-x-1/2">
            <button onClick={() => scrollToSection('home')} className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-400'}`}>
              {t('nav.home')}
            </button>
            <button onClick={() => scrollToSection('about')} className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-400'}`}>
              {t('nav.about')}
            </button>
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-400'}`}>
              {t('nav.services')}
            </button>
            <button onClick={() => scrollToSection('doctors')} className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-400'}`}>
              {t('nav.doctors')}
            </button>
            <button onClick={() => scrollToSection('contact')} className={`text-sm font-medium transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-400'}`}>
              {t('nav.contact')}
            </button>
          </div>

          <div className="hidden lg:flex items-center space-x-3">
            <div className="flex items-center space-x-1 mr-3">
              <button 
                onClick={() => changeLanguage('ru')} 
                className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${i18n.language === 'ru' ? 'bg-teal-600 text-white' : isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'}`}
              >
                RU
              </button>
              <button 
                onClick={() => changeLanguage('ro')} 
                className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${i18n.language === 'ro' ? 'bg-teal-600 text-white' : isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'}`}
              >
                RO
              </button>
              <button 
                onClick={() => changeLanguage('en')} 
                className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${i18n.language === 'en' ? 'bg-teal-600 text-white' : isScrolled ? 'text-gray-700 hover:bg-gray-100' : 'text-white hover:bg-white/10'}`}
              >
                EN
              </button>
            </div>
            <button 
              onClick={() => scrollToSection('contact')}
              className="px-6 py-2.5 bg-teal-600 text-white text-sm font-semibold rounded-lg hover:bg-teal-700 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap"
            >
              {t('nav.appointment')}
            </button>
          </div>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2 rounded-md ${isScrolled ? 'text-gray-700' : 'text-white'}`}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('home')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md whitespace-nowrap">
              {t('nav.home')}
            </button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md whitespace-nowrap">
              {t('nav.about')}
            </button>
            <button onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md whitespace-nowrap">
              {t('nav.services')}
            </button>
            <button onClick={() => scrollToSection('doctors')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md whitespace-nowrap">
              {t('nav.doctors')}
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md whitespace-nowrap">
              {t('nav.contact')}
            </button>
            <div className="px-4 pt-2">
              <button 
                onClick={() => scrollToSection('contact')}
                className="w-full px-6 py-2.5 bg-teal-600 text-white text-sm font-semibold rounded-lg hover:bg-teal-700 transition-all duration-300 whitespace-nowrap"
              >
                {t('nav.appointment')}
              </button>
            </div>
            <div className="flex space-x-2 px-4 pt-2">
              <button onClick={() => changeLanguage('ru')} className={`px-3 py-1.5 text-sm font-medium rounded-md whitespace-nowrap ${i18n.language === 'ru' ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-700'}`}>
                RU
              </button>
              <button onClick={() => changeLanguage('ro')} className={`px-3 py-1.5 text-sm font-medium rounded-md whitespace-nowrap ${i18n.language === 'ro' ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-700'}`}>
                RO
              </button>
              <button onClick={() => changeLanguage('en')} className={`px-3 py-1.5 text-sm font-medium rounded-md whitespace-nowrap ${i18n.language === 'en' ? 'bg-teal-600 text-white' : 'bg-gray-100 text-gray-700'}`}>
                EN
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;